import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Lock } from 'lucide-react';
import { ROUTES } from '../../constants/routes';

interface ArticleAccessProps {
  children: React.ReactNode;
}

const ArticleAccess: React.FC<ArticleAccessProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Only check after auth has completed loading
    if (!isLoading) {
      setShowLoginPrompt(!isAuthenticated);
    }
  }, [isAuthenticated, isLoading]);

  const handleLogin = () => {
    // Simply navigate to the auth page without storing current path
    navigate(ROUTES.AUTH);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (showLoginPrompt) {
    return (
      <div className="container-custom py-8">
        <div className="bg-white rounded-lg shadow-md p-8 text-center max-w-lg mx-auto">
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-primary-600" />
          </div>
          <h2 className="text-2xl font-serif font-bold mb-3">Login Required</h2>
          <p className="text-neutral-600 mb-6">
            Please sign in to access this article and enjoy all content on Legal Nest.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleLogin}
              className="btn btn-primary"
            >
              Sign In
            </button>
            <button
              onClick={() => navigate(ROUTES.HOME)}
              className="btn btn-outline"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  // User is authenticated, show the article content
  return <>{children}</>;
};

export default ArticleAccess;